module.exports = __webpack_public_path__ + "static/media/image-1.fc2d0bfe.png";